import {
  GET_TAGS_SUCCESS,
  ADD_TAGS_SUCCESS,
  SELECT_TAGS,
  LOGOUT_COMPLETE,
  IMPERSONATION_SUCCESS,
  END_IMPERSONATION,
} from '../../constants/actionTypes';
import { keyBy } from 'lodash';

const initialState = {
  tags: {},
  selected: [],
  lastUpdated: null,
};

export const tagsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TAGS_SUCCESS: {
      let tagsInPayload = keyBy(action.result, (tag) => tag);
      return {
        ...state,
        tags: tagsInPayload,
        lastUpdated: action.receivedAt,
      };
    }

    case ADD_TAGS_SUCCESS: {
      let newTags = keyBy(action.requestInfo.tags, (tag) => tag);
      return {
        ...state,
        tags: { ...state.tags, ...newTags },
        lastUpdated: action.receivedAt,
      };
    }

    case SELECT_TAGS:
      return {
        ...state,
        selected: action.tags,
      };

    case IMPERSONATION_SUCCESS:
    case END_IMPERSONATION:
    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};
